import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { filesExistAndValid } from '@certemy/ui-components';
import { Store } from '@ngrx/store';
import { UploadConfirmInfo } from 'components/upload-confirm/confirm-info.interface';

export enum AcceptActionType {
  Accept,
  UploadForVerification,
}

export type AcceptCertificateAction = AcceptAction | UploadForVerificationAction;

export interface AcceptAction {
  type: AcceptActionType.Accept;
}

export interface UploadForVerificationAction {
  type: AcceptActionType.UploadForVerification;
  payload: FormData;
}

@Component({
  selector: 'cm-accept-certification',
  templateUrl: './accept.component.html',
  styleUrls: ['./accept.component.scss'],
})
export class AcceptCertificationComponent implements OnInit {
  @Input() cert;
  files: File[] = [];
  isFullMode = true;
  uploadInfo: UploadConfirmInfo;
  dateForm;
  heading;
  readonly headings = {
    initial: 'Do you currently hold this Credential?',
    upload: 'Please upload the file to confirm credential completion',
  };
  readonly STATES = {
    INITIAL: 1,
    UPLOAD: 2,
  };
  state;
  error = false;
  errorMessages: string[] = [];

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private store: Store<any>) {}

  ngOnInit() {
    this.dateForm = this.fb.group({ date: '' });
    this.goToState(this.STATES.INITIAL);
  }

  close() {
    this.activeModal.dismiss();
  }

  goToState(state) {
    if (state === this.STATES.UPLOAD) {
      this.state = this.STATES.UPLOAD;
      this.heading = this.headings.upload;
    } else if (state === this.STATES.INITIAL) {
      this.state = this.STATES.INITIAL;
      this.heading = this.headings.initial;
    }
  }

  submit() {
    this.errorMessages = [];
    this.error = false;
    const date = this.dateForm.get('date').value;

    if (!date) {
      this.error = true;
      this.errorMessages.push('Please enter date');
      return;
    }

    if (!filesExistAndValid(this.files)) {
      this.error = true;
      this.errorMessages.push('No file(s) detected');
      return;
    }

    this.uploadInfo = {
      textFields: [
        {
          label: 'Credential name:',
          text: this.cert.certificate_name,
        },
      ],
      files: this.files,
    };
    this.isFullMode = false;
  }

  sendAccept() {
    this.activeModal.close({ type: AcceptActionType.Accept });
  }

  sendCertificateForVerification() {
    const formData: FormData = new FormData();
    formData.append('date', this.dateForm.get('date').value);
    for (const file of this.files) {
      formData.append('file[]', file, file.name);
    }
    this.activeModal.close({ type: AcceptActionType.UploadForVerification, payload: formData });
  }

  back() {
    this.isFullMode = true;
  }

  onFilesChange(event) {
    this.files = event;
  }
}
